import { Http } from "./core/http";
var http = new Http();
// 获取分销设置
export function getdistributionList(){
    return http.post('/distribution/distributionConfigList');
}
// 分销设置保存
export function distributionSetting(data){
    return http.post('/distribution/distributionConfigSave',data);
}
// 获取提现设置
export function withdrawalSettings(){
    return http.post('/Extract/extractConfigList');
}
// 保存提现设置
export function saveWithdrawalSettings(data){
    return http.post('Extract/extractConfigSave',data);
}
// 提现列表
export function getWithdrawalList(){
    return http.post('Extract/extractList');
}
// 收益明细
export function revenueBreakdown(data){
    return http.post('users/userDistributionDetails',data)
}
// 分销下级信息
export function distributionUserUnder(data){
    return http.post('users/userLastUser',data)
}
// 分销下级订单
export function distributionUnderorder(data){
    return http.post('users/userLastOrder',data)
}
// 提现审核
export function aditWithdrawal(data){
    return http.post('Extract/extractSave',data);
}
